import React from 'react';

const NcmSubItemContext = React.createContext();

export default NcmSubItemContext;
